import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { IDataReport } from "../interface";

type TArchive = {
    x: string[]
    y: number[]
}

type TMeterInfo = {
  id: string
  resource: string
  sensor_number: string
}

type TReport = {
    archive: TArchive
    meters: TMeterInfo[]
    activeMeterIndex: number
    placeId: string
    activeAddress: [string, string, string]
    namesAddr: [string, string, string]
    time: [string, string]
    offset: number
    data: IDataReport[]
    typeReport: 'Отчет показаний счетчиков воды' | 'Парный 202' | 'Парный 202 без пустых'
}

const initialState: TReport = {
    archive: {
        x: [''],
        y: [0]
    },
    meters: [],
    activeMeterIndex: -1,
    placeId: '',
    activeAddress: ['','',''],
    namesAddr: ['Минск','',''],
    time: ['', ''],
    offset: 0,
    typeReport: 'Отчет показаний счетчиков воды',
    data: [{
        begin_date: '',
        end_date: '',
        begin_value: 0,
        end_value: 0,
        volume: 0,
        address: '',
        account: '',
        device_type: '',
        resource: '',
        sensor_number: '',
        revers: false,
    }]
}

export const reportSlice = createSlice({
    name: 'report',
    initialState,
    reducers: {
        setMeters(state, action: PayloadAction<TMeterInfo[]>) {
            state.meters = action.payload
            state.activeMeterIndex = action.payload.length > 0 ? 0 : -1
        },
        setActiveMeterIndex(state, action: PayloadAction<number>) {
            state.activeMeterIndex = action.payload
        },
        setPlaceIdReducer(state, action: PayloadAction<string>) {
            state.placeId = action.payload
        },
        getArchiveReducer(state, action: PayloadAction<TArchive>) {
            state.archive = action.payload
        },
        setActiveAddreReducer(state, action: PayloadAction<[string, string, string]>) {
            state.activeAddress = [...action.payload]
        },
        setNameAddreReducer(state, action: PayloadAction<[string, string, string]>) {
            state.namesAddr = [...action.payload]
        },
        getTimeReducer(state, action: PayloadAction<[string, string]>) {
            state.time = [...action.payload]
        },
        getOffsetReducer(state, action: PayloadAction<number>) {
            state.offset = action.payload
        },
        getReportDataReducer(state, action: PayloadAction<IDataReport[]>) {
            state.data = [...action.payload]
        },
        setTypeReportReducer(state, action: PayloadAction<'Отчет показаний счетчиков воды' | 'Парный 202' | 'Парный 202 без пустых'>) {
            state.typeReport = action.payload
        },
    },
})

export const {
    setMeters,
    setActiveMeterIndex,
    setPlaceIdReducer,
    getArchiveReducer,
    setActiveAddreReducer,
    setNameAddreReducer,
    getTimeReducer,
    getOffsetReducer,
    getReportDataReducer,
    setTypeReportReducer
} = reportSlice.actions

export default reportSlice.reducer
